
const ChannelSelectData = [
    { label: 'WHATSAPP', value: 'WHATSAPP' },
    { label: 'BALCÃO', value: 'BALCAO' },
    { label: 'TELEFONE', value: 'TELEFONE' },
    { label: 'SITE', value: 'SITE' },
]

export { ChannelSelectData }
